/* LT-Custom-Brev-Section.js */
(function () {
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel)); // querySelectorAll -> array
  }

  function initSection(el) {
    if (!el || el.dataset.ltcbsInit === "true") return; // prevent double init
    el.dataset.ltcbsInit = "true"; // init flag

    const tabs = qsa(el, "[data-tab-btn]"); // tab buttons
    const panels = qsa(el, "[data-panel]"); // tab panels
    const tabsOverflow = el.querySelector("[data-tabs-overflow]"); // overflow viewport
    const tabsList = el.querySelector("[data-tabs]"); // scrollable list
    const btnLeft = el.querySelector("[data-tab-left]"); // left arrow
    const btnRight = el.querySelector("[data-tab-right]"); // right arrow
    const panelsContainer = el.querySelector("[data-panels]"); // Apple-style fading panel stack

    if (!tabs.length || !panels.length) return; // nothing to do

    const panelsById = new Map(
      panels.map((panel) => [panel.getAttribute("data-panel"), panel])
    );
    let panelHeightFrame = null;
    let panelResizeObserver = null;
    let panelsAnimatedFrame = null;

    function initCardSwatches(scope) {
      qsa(scope || el, "[data-card]").forEach((card) => {
        if (!card || card.dataset.ltcbsSwatchInit === "true") return; // per-card guard
        card.dataset.ltcbsSwatchInit = "true"; // per-card init flag

        const img = card.querySelector("[data-card-img]"); // main image
        if (!img) return; // no image, no swap

        const defaultSrc = img.getAttribute("data-default-src") || img.getAttribute("src"); // default src
        const defaultSrcset = img.getAttribute("data-default-srcset") || img.getAttribute("srcset"); // default srcset

        const swatches = qsa(card, "[data-swatch]"); // swatch <li> items
        if (!swatches.length) return; // no swatches

        function setImg(src, srcset) {
          if (!src) return; // ignore empty
          img.setAttribute("src", src); // swap src
          if (srcset) img.setAttribute("srcset", srcset); // swap srcset
        }

        function restore() {
          setImg(defaultSrc, defaultSrcset); // restore default image
        }

        swatches.forEach((sw) => {
          const src = sw.getAttribute("data-swatch-src"); // swatch target src
          const srcset = sw.getAttribute("data-swatch-srcset"); // swatch target srcset

          sw.addEventListener("mouseenter", () => setImg(src, srcset)); // hover preview
          sw.addEventListener("mouseleave", restore); // hover out restore
        });

        card.addEventListener("mouseleave", restore); // safety reset when leaving the whole card
      });
    }

    function getActivePanel() {
      return panels.find((panel) => panel.classList.contains("is-active")) || panels[0];
    }

    function prewarmPanelImages(panel) {
      qsa(panel, ".product-grid > li img").slice(0, 6).forEach((image) => {
        if (image.dataset.ltcbsPrewarmed === "true") return;
        image.dataset.ltcbsPrewarmed = "true";
        image.dataset.ltcbsTabImage = "true";
        image.dataset.ltcbsImageReady = "false";
        image.loading = "eager";

        const revealImage = () => {
          image.dataset.ltcbsImageReady = "true";
        };

        if (typeof image.decode === "function") {
          image.decode().then(revealImage, revealImage);
        } else if (image.complete) {
          revealImage();
        } else {
          image.addEventListener("load", revealImage, { once: true });
          image.addEventListener("error", revealImage, { once: true });
        }
      });
    }

    function syncPanelHeight(panel) {
      if (!panelsContainer || !panel || !panel.isConnected) return;

      const measuredHeight = panel.getBoundingClientRect().height;
      if (measuredHeight <= 0) return;

      panelsContainer.style.setProperty("--ltcbs-panel-height", `${Math.ceil(measuredHeight)}px`);
    }

    function schedulePanelHeight(panel) {
      if (!panelsContainer || !panel) return;
      if (panelHeightFrame) window.cancelAnimationFrame(panelHeightFrame);

      panelHeightFrame = window.requestAnimationFrame(() => {
        panelHeightFrame = null;
        if (panel.classList.contains("is-active")) syncPanelHeight(panel);
      });
    }

    function dispatchPanelShown(id, panel) {
      el.dispatchEvent(
        new CustomEvent("ltcbs:panel-shown", {
          detail: { id, panel },
        })
      );
    }

    function setActive(id, notify = true) {
      const target = panelsById.get(id);
      if (!target) return;

      const previous = getActivePanel();
      const changed = previous !== target;

      tabs.forEach((b) => {
        const on = b.getAttribute("data-tab-btn") === id; // active match
        b.setAttribute("aria-selected", on ? "true" : "false"); // aria update
      });

      panels.forEach((p) => {
        const on = p.getAttribute("data-panel") === id; // active match
        p.hidden = false; // all panels stay measurable for the delayed crossfade

        if (on) {
          p.classList.add("is-active"); // state class
          p.removeAttribute("aria-hidden");
          p.removeAttribute("inert");
          initCardSwatches(p); // swatches for visible panel
        } else {
          p.classList.remove("is-active"); // remove state
          p.setAttribute("aria-hidden", "true");
          p.setAttribute("inert", "");
        }
      });

      prewarmPanelImages(target);

      if (notify && changed) dispatchPanelShown(id, target);
      syncPanelHeight(target);
      schedulePanelHeight(target);
    }

    tabs.forEach((b) => {
      const id = b.getAttribute("data-tab-btn");
      const prewarm = () => prewarmPanelImages(panelsById.get(id));

      b.addEventListener("pointerenter", prewarm, { passive: true });
      b.addEventListener("focus", prewarm);
      b.addEventListener("touchstart", prewarm, { passive: true });
      b.addEventListener("click", () => setActive(id)); // click -> delayed panel crossfade
    });

    const initialId =
      tabs.find((tab) => tab.getAttribute("aria-selected") === "true")?.getAttribute("data-tab-btn") ||
      tabs[0].getAttribute("data-tab-btn");

    setActive(initialId, false); // preserve the server-selected first panel

    window.requestAnimationFrame(() => {
      const initialPanel = getActivePanel();
      syncPanelHeight(initialPanel);

      if (panelsContainer) {
        panelsContainer.setAttribute("data-ltcbs-panels-ready", "true");
        panelsAnimatedFrame = window.requestAnimationFrame(() => {
          panelsAnimatedFrame = null;
          panelsContainer.setAttribute("data-ltcbs-panels-animated", "true");
          syncPanelHeight(getActivePanel());
        });
      }
    });

    if (typeof ResizeObserver === "function") {
      panelResizeObserver = new ResizeObserver((entries) => {
        const activePanel = getActivePanel();
        if (entries.some((entry) => entry.target === activePanel)) {
          schedulePanelHeight(activePanel);
        }
      });

      panels.forEach((panel) => panelResizeObserver.observe(panel));
    }

    function updateArrows() {
      if (!btnLeft || !btnRight || !tabsOverflow || !tabsList) return; // arrows not present

      const canScroll = tabsList.scrollWidth > tabsOverflow.clientWidth + 2; // overflow check
      if (!canScroll) {
        btnLeft.hidden = true; // no scroll -> hide
        btnRight.hidden = true;
        return;
      }

      const left = tabsList.scrollLeft; // current scroll
      const max = tabsList.scrollWidth - tabsOverflow.clientWidth; // max scroll
      btnLeft.hidden = left <= 2; // hide when near start
      btnRight.hidden = left >= max - 2; // hide when near end
    }

    function scrollTabs(dir) {
      if (!tabsList || !tabsOverflow) return; // guard
      const amount = Math.max(220, Math.floor(tabsOverflow.clientWidth * 0.65)); // scroll chunk
      tabsList.scrollBy({ left: dir * amount, behavior: "smooth" }); // smooth scroll
    }

    if (btnLeft && btnRight && tabsList) {
      btnLeft.addEventListener("click", () => scrollTabs(-1)); // left
      btnRight.addEventListener("click", () => scrollTabs(1)); // right
      tabsList.addEventListener("scroll", () => requestAnimationFrame(updateArrows), { passive: true }); // update on scroll
      window.addEventListener("resize", () => requestAnimationFrame(updateArrows)); // update on resize
      requestAnimationFrame(updateArrows); // initial update
    }

    function handleSectionUnload(event) {
      if (event.target !== el && !event.target.contains(el)) return;

      if (panelHeightFrame) window.cancelAnimationFrame(panelHeightFrame);
      if (panelsAnimatedFrame) window.cancelAnimationFrame(panelsAnimatedFrame);
      if (panelResizeObserver) panelResizeObserver.disconnect();
      document.removeEventListener("shopify:section:unload", handleSectionUnload);
    }

    document.addEventListener("shopify:section:unload", handleSectionUnload);
  }

  function initAll(root) {
    qsa(root || document, "[data-ltcbs]").forEach(initSection); // init each section instance
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document)); // initial load
  document.addEventListener("shopify:section:load", (e) => initAll(e.target)); // theme editor load
  document.addEventListener("shopify:section:select", (e) => initAll(e.target)); // theme editor select
})();
